// import Dashboard from "../views/Dashboard.vue";
// import Listing from "../components/listing/ListingLayout.vue";
// import Profile from "../components/profile/Profile.vue";
// import ManageOrders from "../components/order/Order.vue";
// import Inbox from "../components/inbox/Inbox.vue";
// import Requests from "../components/rfp/Requests.vue";
// import Watchlist from "../components/watchlist/Watchlist.vue";
// import Notification from "../components/notification/Notification.vue";
// import Quotations from "../components/rfp/Quotations.vue";
import store from "../../../store"
import AuthHelper from "../../../common/helpers/AuthHelper";
import BecomeAServiceCenter from "../components/serviceCenter/BecomeAServiceCenter.vue";

const Dashboard = () => import('../views/Dashboard.vue');
const Listing = () => import('../components/listing/ListingLayout.vue');
const MyAccount = () => import('../components/MyAccount/MyAccountLayout.vue');
const Profile = () => import('../components/profile/Profile.vue');
const ManageOrders = () => import('../components/order/Order.vue');
const Inbox = () => import('../components/inbox/Inbox.vue');
const RequestLayout = () => import('../components/rfp/RequestLayout.vue');
const Requests = () => import('../components/rfp/Requests.vue');
const Watchlist = () => import('../components/watchlist/Watchlist.vue');
const Notification = () => import('../components/notification/Notification.vue');
const NotificationSettings = () => import('../components/notification/NotificationSettings.vue');
const Sales = () => import('../components/sales/Sales.vue');
const Quotations = () => import('../components/rfp/Quotations.vue');
const Chat = () => import ('../../product-details/components/chat/Chat.vue');
const ReceivedQuotation = ()=>import('../components/rfp/components/ReceivedQuotation.vue')
// const store = () => import('../../../store');
// const AuthHelper = () => import('../../../common/helpers/AuthHelper');



export default [{
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    // meta: { conditionalRoute: true },
    beforeEnter: async () => {
        if (!AuthHelper.checkAuthForAction(store)) return;
        // <script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCesypEBJ5FruuIgJUF9PiiNJC1cB-Udag&libraries=places&callback=initMap"></script>

        // const gMaps = document.getElementById('gMaps')
        // if (!gMaps)
        // {
        //     await new Promise(
        //         (resolve)=>
        //         {
        //             let googleMapsTag = document.createElement("script");
        //             googleMapsTag.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCesypEBJ5FruuIgJUF9PiiNJC1cB-Udag&libraries=places&callback=initMap";
        //             googleMapsTag.id = 'gMaps'
        //             document.getElementsByTagName("head")[0].appendChild(googleMapsTag);
        //             googleMapsTag.onload = function(){
        //                 resolve()
        //             }
        //         }
        //     )
            
        // }
        
    },
    children: [{
            path: "profile",
            name: "Profile",
            component: Profile,
        },
        {
            path: "listings",
            name: "Listing",
            component: Listing,
        },
        {
            path: "negotiations",
            name: "Inbox",
            component: Inbox,
        },
        {
            path: "negotiations/:id",
            name: "Inbox-chat",
            component: Inbox,
        },
        {
            path: "myAccount",
            name: "MyAccount",
            component: MyAccount,
        },
        {
            path: "notifications",
            name: "Notifications",
            component: Notification,
        },
        {
            path: "notifications/settings",
            name: "NotificationSettings",
            component: NotificationSettings,
        },
        {
            path: "watch-list",
            name: "WatchList",
            component: Watchlist,
        },
        {
            path: "orders",
            name: "Orders",
            component: ManageOrders,
        },
        {
            path: "settings",
            name: "Settings",
            component: Listing,
        },
        {
            path: "requests",
            name: "Requests",
            component: RequestLayout,
        },
        {
            path: "quotations",
            name: "Quotations",
            component: Quotations,
        },

        {
            path: "negotiations/:chatId",
            name: "chat",
            component: Chat,
        },
        {
            path: "sales",
            name: "Sales",
            component: Sales,
        },

        {
            path: "offers/:rfpId",
            name: "Offers",
            component: ReceivedQuotation,
        },

        {
            path: "become-a-service-center",
            name: "BecomeAServiceCenter",
            component: BecomeAServiceCenter,
        },
    ],
}, ];